import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { StatusEnum } from "../../../../../commons/enums/status-enum";
import { manageFootballTeamService } from "../../../../../commons";
import { PaginatedEnsueCollection } from "../../../../../ensue-react-system/utilities/paginated-ensue-collection";
import { User } from "../../../../../commons/models/user";

export interface ITeamUsersAvailableOptions {
  teamId: number;
  urlOption?: {
    page?: number;
    perPage?: number;
    sort?: string;
    sortOrder?: "DESC" | "ASC";
    name?: string;
    status?: string;
  };
}
export interface IManageTeamUsersAvailableState {
  teamUsersAvailable: PaginatedEnsueCollection<User>;
  teamUsersAvailableStatus: StatusEnum;
}

const initialState: IManageTeamUsersAvailableState = {
  teamUsersAvailable: new PaginatedEnsueCollection<User>(),
  teamUsersAvailableStatus: StatusEnum.Idle,
};

export const fetchManageTeamUsersAvailable = createAsyncThunk(
  "manage/teamUsersAvailable",
  async (options: ITeamUsersAvailableOptions, thunkAPI) => {
    try {
      const playersNotInTeam = await manageFootballTeamService.getUsersAvailableForTeam(
        options.teamId,
        options.urlOption
      );
      return playersNotInTeam as PaginatedEnsueCollection<User>;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

const footballManageTeamUsersAvailableSlice = createSlice({
  name: "footballManageTeamUsersAvailable",
  initialState: initialState,
  reducers: {
    cleanUpTeamUsersAvailable(state) {
      state.teamUsersAvailable = new PaginatedEnsueCollection<User>();
      state.teamUsersAvailableStatus = StatusEnum.Idle;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchManageTeamUsersAvailable.pending, (state) => {
        state.teamUsersAvailableStatus = StatusEnum.Loading;
      })
      .addCase(
        fetchManageTeamUsersAvailable.fulfilled,
        (state, action: PayloadAction<PaginatedEnsueCollection<User>>) => {
          state.teamUsersAvailableStatus = StatusEnum.Succeeded;
          state.teamUsersAvailable = action.payload;
        }
      )
      .addCase(fetchManageTeamUsersAvailable.rejected, (state) => {
        state.teamUsersAvailableStatus = StatusEnum.Failed;
      });
  },
});

export const { cleanUpTeamUsersAvailable } = footballManageTeamUsersAvailableSlice.actions;
export default footballManageTeamUsersAvailableSlice.reducer;
